import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutTopBottom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconLayoutTopBottom"><Path d="M21 21H3V19.5H21V21Z" fill="currentColor"/><Path d="M21 17H3V7H21V17Z" fill="currentColor"/><Path d="M21 4.5H3V3H21V4.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutTopBottom;
